import './Shop.css';
import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import categories from '../../data/categories';
import Card from '../../components/Card/Card';

function Shop() {
    let guitars = useSelector(state => state.guitars);
    
    const [sortOption, setSortOption] = useState("New"); // 초기값 설정

    // 정렬된 데이터 계산 (useMemo로 성능 최적화)
    const sortedGuitars = useMemo(() => {
        let sorted = [...guitars];
        if (sortOption === "New") {
            // sorted.sort((a, b) => new Date(b.updated) - new Date(a.updated)); // 최신순
        } else if (sortOption === "High Price") {
            sorted.sort((a, b) => b.price - a.price); // 높은 가격순
        } else if (sortOption === "Low Price") {
            sorted.sort((a, b) => a.price - b.price); // 낮은 가격순
        } else if (sortOption === "Name: A-Z") {
            sorted.sort((a, b) => a.title.localeCompare(b.title)); // 이름순
        }
        return sorted;
    }, [guitars, sortOption]);

    // 페이지네이션 상태
    const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
    const itemsPerPage = 12; // 페이지당 표시할 카드 수
    const totalPages = Math.ceil(guitars.length / itemsPerPage); // 전체 페이지 수

    // 현재 페이지에 표시할 아이템 계산
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentGuitars = sortedGuitars.slice(startIndex, endIndex);

    // 페이지 변경 핸들러
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    

    return (
        <div className="shop common-padding">
            {/* 좌측 필터 */}
            <div className="shop__left">
                {categories.map((category, index) => (
                    <div className="shop__left-category" key={index}>
                        <h2>{category.name}</h2>
                        <div className="shop__left-subCategory">
                            {category.subcategories.map((sub, idx) => (
                                <div key={idx}>{sub}</div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* 우측 메인 콘텐츠 */}
            <div className="shop__right">
                <div className="shop__right-top">
                    {/* <div className="shop__sort">
                        Sort by: New ▼
                        <div className="shop__sort-dropdown">
                            <p>New</p>
                            <p>Most Viewed</p>
                            <p>Product Name A-Z</p>
                        </div>
                    </div> */}
                    <span>Sort by : </span>
                    <select
                        className="shop__sort"
                        value={sortOption} // 현재 선택된 값
                        onChange={(e) => {
                            setSortOption(e.target.value)
                            handlePageChange(1)
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                    >
                        <option value="New">New</option>
                        <option value="High Price" onClick={()=>{

                        }}>High Price</option>
                        <option value="Low Price">Low Price</option>
                        <option value="Name: A-Z">Name: A-Z</option>
                    </select>
                </div>

                <div className="shop__right-main">
                    {currentGuitars.map((guitar, index) => (
                        <Card key={index} guitar={guitar} className="shop__right-card" />
                    ))}
                </div>

                {/* 페이지네이션 */}
                <div className="pagination">
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            className={`pagination__button ${currentPage === index + 1 ? 'active' : ''}`}
                            onClick={() => {
                                handlePageChange(index + 1)
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Shop;
